import { Card, Flex, Typography } from 'antd';
import { Outlet } from 'react-router-dom';
import { useBreakpoint } from '@/shared/lib/hooks';
import { safeAreaPadding } from '@/shared/lib/mobileUi';

const APP_NAME = 'Учёт товаров';

export function AuthLayout() {
  const { isMobile } = useBreakpoint();

  if (isMobile) {
    // Телефон: без рамки-карточки, на белом фоне; форма по центру видимой области. Контейнер лишь
    // не ниже видимой области (с учётом экранной клавиатуры iOS), а не фиксированной высоты — при
    // нехватке места он растёт и страница прокручивается, кнопка отправки не прячется.
    return (
      <div
        style={{
          minHeight: 'var(--vv-height, 100dvh)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          background: '#fff',
          padding: safeAreaPadding(16),
        }}
      >
        <Flex vertical gap={24} style={{ width: '100%', maxWidth: 400, margin: '0 auto' }}>
          <Typography.Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            {APP_NAME}
          </Typography.Title>
          <Outlet />
        </Flex>
      </div>
    );
  }

  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh', padding: 16 }}>
      <Card style={{ width: '100%', maxWidth: 400 }}>
        <Flex vertical gap={24}>
          <Typography.Title level={3} style={{ margin: 0, textAlign: 'center' }}>
            {APP_NAME}
          </Typography.Title>
          <Outlet />
        </Flex>
      </Card>
    </Flex>
  );
}
